module.exports = [
  {
    label: "So funktioniert's",
    href: '/how-it-works',
  },
  {
    label: 'Treffen finden',
    href: '/discover',
  },
  {
    label: 'Gastgeber werden',
    href: '/become-a-host',
  },
  // {
  //   label: 'Preise',
  //   href: '/pricing',
  // },
  // {
  //   label: 'Hilfe',
  //   href: '/help',
  // },
  {
    label: 'AGB',
    href: '/terms',
  },
];
